var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"c-userIcon",style:(_vm.style),attrs:{"src":_vm.$coconala.userIconURL(!_vm.hasError ? _vm.filePath : null),"alt":_vm.userName,"loading":"lazy","decoding":"async"}})}
var staticRenderFns = []

export { render, staticRenderFns }